import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";

export default function AdminLogin() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success("Bem-vindo!");
            navigate("/admin");
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6 py-12">
            <div className="w-full max-w-md">
                <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/50 hover:text-white mb-8" data-testid="login-back">
                    <ArrowLeft className="w-4 h-4" /> Voltar
                </Link>
                <div className="ab-card p-8 lg:p-10">
                    <div className="flex flex-col items-center gap-4 mb-8">
                        <Logo variant="full" size={140} />
                        <div className="text-xs text-[#C9A961] uppercase tracking-widest">Painel de administração</div>
                    </div>
                    <form onSubmit={onSubmit} className="space-y-5">
                        <div>
                            <Label htmlFor="email">E-mail</Label>
                            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
                        </div>
                        <div>
                            <Label htmlFor="pwd">Palavra-passe</Label>
                            <Input id="pwd" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
                        </div>
                        <Button type="submit" disabled={loading} className="ab-btn-primary w-full rounded-none h-12 uppercase tracking-widest font-semibold" data-testid="login-submit">
                            {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
                            Entrar
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
}
